/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_CalisthenicsInputs */

const en_us2_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calisthenics`)
};

const pt_br2_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calistenia`)
};

const es_419_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calistenia`)
};

const pt_pt2_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calistenia`)
};

const fr_fr2_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Callisthénie`)
};

const de_de2_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calisthenics`)
};

const it_it2_modality_calisthenics = /** @type {(inputs: Modality_CalisthenicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calistenia`)
};

/**
* | output |
* | --- |
* | "Calisthenics" |
*
* @param {Modality_CalisthenicsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_calisthenics = /** @type {((inputs?: Modality_CalisthenicsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_CalisthenicsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_calisthenics(inputs)
	if (locale === "es-419") return es_419_modality_calisthenics(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_calisthenics(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_calisthenics(inputs)
	if (locale === "de-DE") return de_de2_modality_calisthenics(inputs)
	if (locale === "it-IT") return it_it2_modality_calisthenics(inputs)
	return en_us2_modality_calisthenics(inputs)
});
export { modality_calisthenics as "modality.calisthenics" }